// Mock data para o site de pisos e azulejos

export const companyInfo = {
  name: "JC FLOORS & TILES",
  fullName: "JC FLOORS & TILES UNIPESSOAL LDA",
  phone: "+351 961 531 199",
  whatsapp: "351961531199",
  email: "cosney_oliveira@hotmail.com",
  address: "Monte São Jose 630x",
  locality: "8375-052 São Bartolomeu de Messines",
  fullAddress: "Monte São Jose 630x, 8375-052 São Bartolomeu de Messines, Portugal",
  instagram: "@jc_floors_tiles",
  instagramUrl: "https://www.instagram.com/jc_floors_tiles?igsh=cngwNTVsb21jcnF6"
};

export const services = [
  {
    id: 1,
    title: { pt: "Cerâmica", en: "Ceramic Tiles" },
    description: { 
      pt: "Instalação de cerâmica para pisos e paredes com acabamento profissional.",
      en: "Ceramic tile installation for floors and walls with professional finishing."
    },
    icon: "Square"
  },
  {
    id: 2,
    title: { pt: "Porcelanato", en: "Porcelain Tiles" },
    description: { 
      pt: "Aplicação de porcelanato de alta qualidade para ambientes sofisticados.",
      en: "High-quality porcelain tile application for sophisticated spaces."
    },
    icon: "Layers"
  },
  {
    id: 3,
    title: { pt: "Pedra Natural", en: "Natural Stone" },
    description: { 
      pt: "Instalação de mármore, granito e outras pedras naturais.",
      en: "Installation of marble, granite and other natural stones."
    },
    icon: "Gem"
  },
  {
    id: 4,
    title: { pt: "Piso Vinílico", en: "Vinyl Flooring" },
    description: { 
      pt: "Aplicação de piso vinílico moderno, resistente e de fácil manutenção.",
      en: "Modern vinyl flooring application, durable and easy to maintain."
    },
    icon: "Grid3x3"
  },
  {
    id: 5,
    title: { pt: "Laminado", en: "Laminate" },
    description: { 
      pt: "Instalação de piso laminado com visual de madeira e alta durabilidade.",
      en: "Laminate flooring installation with wood look and high durability."
    },
    icon: "Box"
  },
  {
    id: 6,
    title: { pt: "Azulejos Exterior", en: "Outdoor Tiles" },
    description: { 
      pt: "Instalação de azulejos antiderrapantes para áreas externas.",
      en: "Non-slip tile installation for outdoor areas."
    },
    icon: "Home"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Maria Silva",
    location: "Lisboa, Portugal",
    text: {
      pt: "Trabalho impecável! Instalaram porcelanato na minha sala e ficou perfeito. Equipe profissional e pontual.",
      en: "Impeccable work! They installed porcelain in my living room and it was perfect. Professional and punctual team."
    },
    rating: 5,
    date: { pt: "Janeiro 2025", en: "January 2025" }
  },
  {
    id: 2,
    name: "João Santos",
    location: "Porto, Portugal",
    text: {
      pt: "Excelente atendimento e acabamento perfeito. O piso vinílico ficou exatamente como eu imaginava. Super recomendo!",
      en: "Excellent service and perfect finishing. The vinyl flooring was exactly as I imagined. Highly recommend!"
    },
    rating: 5,
    date: { pt: "Dezembro 2024", en: "December 2024" }
  },
  {
    id: 3,
    name: "Ana Paula Costa",
    location: "Faro, Portugal",
    text: {
      pt: "Profissionais competentes e trabalho de qualidade. Os azulejos ficaram lindos e funcionais. Muito satisfeita!",
      en: "Competent professionals and quality work. The tiles were beautiful and functional. Very satisfied!"
    },
    rating: 5,
    date: { pt: "Novembro 2024", en: "November 2024" }
  },
  {
    id: 4,
    name: "Carlos Oliveira",
    location: "Coimbra, Portugal",
    text: {
      pt: "Contratei para colocar cerâmica no meu escritório. Trabalho rápido, limpo e com ótimo acabamento. Parabéns!",
      en: "I hired them to install ceramic in my office. Fast, clean work with great finishing. Congratulations!"
    },
    rating: 5,
    date: { pt: "Outubro 2024", en: "October 2024" }
  }
];

export const gallery = [
  {
    id: 1,
    title: { pt: "Instalação de Azulejos - Casa de Banho", en: "Tile Installation - Bathroom" },
    category: "toilet",
    image: "/gallery-1.jpg"
  },
  {
    id: 2,
    title: { pt: "Revestimento em Pedra Natural", en: "Natural Stone Cladding" },
    category: "toilet",
    image: "/gallery-2.jpg"
  },
  {
    id: 3,
    title: { pt: "Instalação de Porcelanato - Parede", en: "Porcelain Installation - Wall" },
    category: "toilet",
    image: "/gallery-3.jpg"
  },
  {
    id: 4,
    title: { pt: "Revestimento Completo - Casa de Banho", en: "Complete Cladding - Bathroom" },
    category: "toilet",
    image: "/gallery-4.jpg"
  },
  {
    id: 5,
    title: { pt: "Piso e Parede - Projeto Residencial", en: "Floor and Wall - Residential Project" },
    category: "toilet",
    image: "/gallery-5.jpg"
  },
  {
    id: 6,
    title: { pt: "Casa de Banho com Nicho Embutido", en: "Bathroom with Built-in Niche" },
    category: "toilet",
    image: "/gallery-6.jpg"
  },
  {
    id: 7,
    title: { pt: "Revestimento Completo - Duche", en: "Complete Shower Cladding" },
    category: "toilet",
    image: "/gallery-7.jpg"
  },
  {
    id: 8,
    title: { pt: "Casa de Banho com Nicho Decorativo", en: "Bathroom with Decorative Niche" },
    category: "toilet",
    image: "/gallery-8.jpg"
  },
  {
    id: 9,
    title: { pt: "Acabamento Premium - Casa de Banho", en: "Premium Finish - Bathroom" },
    category: "toilet",
    image: "/gallery-9.jpg"
  },
  {
    id: 10,
    title: { pt: "Escada de Piscina - Design Personalizado", en: "Pool Stairs - Custom Design" },
    category: "pool",
    image: "/gallery-10.jpg"
  },
  {
    id: 11,
    title: { pt: "Deck de Piscina - Porcelanato Exterior", en: "Pool Deck - Outdoor Porcelain" },
    category: "pool",
    image: "/gallery-11.jpg"
  },
  {
    id: 12,
    title: { pt: "Piscina com Deck - Vista Panorâmica", en: "Pool with Deck - Panoramic View" },
    category: "pool",
    image: "/gallery-12.jpg"
  },
  {
    id: 13,
    title: { pt: "Corredor Comercial - Shopping", en: "Commercial Corridor - Shopping" },
    category: "shopping",
    image: "/gallery-13.jpg"
  },
  {
    id: 14,
    title: { pt: "Corredor Comercial - Acabamento Profissional", en: "Commercial Corridor - Professional Finish" },
    category: "shopping",
    image: "/gallery-14.jpg"
  },
  {
    id: 15,
    title: { pt: "Equipe Profissional - Instalação de Nicho", en: "Professional Team - Niche Installation" },
    category: "bedroom",
    image: "/gallery-15.jpg"
  },
  {
    id: 16,
    title: { pt: "Trabalho em Progresso - Piscina", en: "Work in Progress - Pool" },
    category: "pool",
    image: "/gallery-16.jpg"
  },
  {
    id: 17,
    title: { pt: "Acabamento Profissional - Banheiro", en: "Professional Finish - Bathroom" },
    category: "toilet",
    image: "/gallery-17.jpg"
  },
  {
    id: 18,
    title: { pt: "Mosaico Hexagonal - Design Personalizado", en: "Hexagonal Mosaic - Custom Design" },
    category: "mosaic",
    image: "/gallery-18.jpg"
  },
  {
    id: 19,
    title: { pt: "Casa de Banho com Azulejo Branco", en: "Bathroom with White Tile" },
    category: "toilet",
    image: "/gallery-19.jpg"
  },
  {
    id: 20,
    title: { pt: "Instalação Azulejo Branco", en: "White Tile Installation" },
    category: "toilet",
    image: "/gallery-20.jpg"
  },
  {
    id: 21,
    title: { pt: "Casa de Banho em Construção - Personalizado", en: "Bathroom Under Construction - Custom" },
    category: "toilet",
    image: "/gallery-21.jpg"
  },
  {
    id: 22,
    title: { pt: "Instalação Completa - Casa de Banho", en: "Complete Installation - Bathroom" },
    category: "toilet",
    image: "/gallery-22.jpg"
  },
  {
    id: 23,
    title: { pt: "Duche em Construção - Porcelanato", en: "Shower Under Construction - Porcelain" },
    category: "toilet",
    image: "/gallery-23.jpg"
  }
];

export const faqs = [
  {
    id: 1,
    question: { 
      pt: "Qual o prazo médio para instalação de piso?",
      en: "What is the average time for floor installation?"
    },
    answer: { 
      pt: "O prazo varia de acordo com o tamanho do ambiente, mas em média um cômodo de 20m² leva de 2 a 3 dias para conclusão completa.",
      en: "The timeframe varies according to room size, but on average a 20m² room takes 2-3 days for complete installation."
    }
  },
  {
    id: 2,
    question: { 
      pt: "Qual tipo de piso é melhor para cozinha?",
      en: "What type of flooring is best for kitchens?"
    },
    answer: { 
      pt: "Recomendamos porcelanato ou cerâmica por serem resistentes à água e fáceis de limpar. Ambos são ideais para áreas molhadas.",
      en: "We recommend porcelain or ceramic tiles as they are water-resistant and easy to clean. Both are ideal for wet areas."
    }
  },
  {
    id: 3,
    question: { 
      pt: "Vocês fornecem garantia dos serviços?",
      en: "Do you provide warranty for services?"
    },
    answer: { 
      pt: "Sim, todos os nossos serviços possuem garantia de 1 ano contra defeitos de instalação e acabamento.",
      en: "Yes, all our services come with a 1-year warranty against installation defects and finishing."
    }
  },
  {
    id: 4,
    question: { 
      pt: "É possível fazer orçamento sem visita técnica?",
      en: "Is it possible to get a quote without a technical visit?"
    },
    answer: { 
      pt: "Podemos fazer uma estimativa inicial por fotos e medidas, mas recomendamos a visita técnica para um orçamento mais preciso.",
      en: "We can provide an initial estimate from photos and measurements, but we recommend a technical visit for a more accurate quote."
    }
  },
  {
    id: 5,
    question: { 
      pt: "Vocês trabalham em finais de semana?",
      en: "Do you work on weekends?"
    },
    answer: { 
      pt: "Trabalhamos aos sábados até 13h. Para serviços em domingos e feriados, consulte disponibilidade com antecedência.",
      en: "We work on Saturdays until 1pm. For services on Sundays and holidays, please check availability in advance."
    }
  }
];